import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ENDPOINT, STRIPE_SESSION_PAYMENT_VERIFY } from "../../components/Service";
import { Context } from "../../components/Context";
import { showAlertMsg } from "../../components/CommonMethod";

export const onCheckoutSuccessEvent = async (queryString, setContext, navigate) => {
    const request = { method: 'get', headers: { 'Content-Type': 'application/json' } };
    const response = await fetch(`${ENDPOINT}${STRIPE_SESSION_PAYMENT_VERIFY}${queryString}`, request).then(res => res.json());
    if (response && response.records) {
        localStorage.setItem('waae-token', response.records.access_token);
        setContext(prevState => ({ ...prevState, auth: response.records }));
        if (navigate) navigate('/checkout-successful', { state: { payment: true } });
        else return true;
    } else {
        showAlertMsg({ error: response?.error || 'Opps something went wrong' });
        return false;
    }
}

function CheckoutSuccess() {
    window.document.title = "Checkout-Successful";
    const checkout_url = window.location.search
    const navigate = useNavigate()
    const location = useLocation()
    const [, setContext] = useContext(Context);
    const [verification, setVerification] = useState('in-progress');

    useEffect(() => {
        const session_query = checkout_url ? (checkout_url?.includes('stripe_session_id') ?? checkout_url?.includes('payment_intent_id')) : false;        
        if (session_query) {
            (async () => {
                const data = await onCheckoutSuccessEvent(`${checkout_url}`, setContext, false);
                setVerification(data ? 'success' : 'failed');
            })();
        } else if (location?.state) {
            setVerification('success');
        } else {
            navigate('/shop-list');
        }
        // eslint-disable-next-line
    }, [checkout_url, navigate, location])


    return (
        <section className="setpage-height pt-5">
            <div className="container container-1040">
                <div className="row justify-content-center">
                    <div className="col-sm-10 col-md-7 pt-4">
                        <div className="rounded-4 border border-blue border border-2 p-4">
                            {verification === 'in-progress' && <h3 className="fw-bold text-yellow">Please wait...</h3>}
                            {verification === 'success' && <>
                                <h3 className="fw-bold text-success">Purchase successful</h3>
                                <p className="h4 text-blue py-3 fw-normal lh-sm">
                                Congratulations! Welcome to the interactive study guide. Check out your study guide below to start mastering chemistry now.
                                </p>
                            </>}
                            {verification === 'failed' && <>
                                <h3 className="fw-bold text-danger">Purchase failed</h3>
                                <p className="h4 text-blue py-3 fw-normal lh-sm">
                                    Unable to process your payment. Please contact to adminisrator
                                </p>
                            </>}
                            <Link to="/my-workbooks" className="btn btn-theme-primary btn-lg w-100 mt-2">Yes, I want I want to master chemistry</Link>
                        </div>
                    </div>
                    <div className="col-sm-8 col-md-5">
                        <img src="images/female-student.png" className="img-fluid" alt="male" />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default CheckoutSuccess
